// extracted by mini-css-extract-plugin
export default {"icon":"_1Omv6VzT3bPH3mZj3uiaEb"};